import { api } from '@/api/api-client.config.ts';
import { SelectionType } from '@/@types/api.types.ts';
import { useQuery } from '@tanstack/react-query';

interface GetUserSelectionsProps {
  pickemId: number;
  userId: number;
}

const getUserSelections = ({ pickemId, userId }: GetUserSelectionsProps) =>
  api.get<void, { selections: SelectionType[] }>(
    `/admin/pickems/${pickemId}/user-selections/${userId}`
  );

export const useGetUserSelectionsQuery = ({
  pickemId,
  userId,
}: GetUserSelectionsProps) => {
  return useQuery({
    queryKey: ['getUserSelections', pickemId, userId],
    queryFn: () => getUserSelections({ pickemId, userId }),
    enabled: Boolean(pickemId) && Boolean(userId),
    select: (data) => data.selections,
  });
};
